import { Stack, Typography } from "@braintrust/braintrust-ui-components";
import { type Modal, ModalInstance } from "@js/components/modal";

import styles from "./style.module.scss";

type AILoadingModalProps = { text: string };

export const AILoadingModal = ({ text }: AILoadingModalProps) => {
  return (
    <Stack
      sx={{
        alignItems: "center",
        gap: "24px",
      }}
    >
      <Stack
        sx={{
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          height: "86px",
          width: "86px",
          textAlign: "center",
        }}
      >
        <img
          src={`${SETTINGS.STATIC_URL}jobs/ai-job-loader.png`}
          className={styles.loader}
          alt="loader"
          width="86"
          height="86"
        />
        <img
          src={`${SETTINGS.STATIC_URL}jobs/ai-job-icon-star.svg`}
          height="34"
          width="34"
          alt="loader icon"
        />
      </Stack>

      <Typography component="span" fontWeight={500} size="large" sx={{ mt: 2 }}>
        {text}
      </Typography>
    </Stack>
  );
};

export const openAILoadingModal = ({
  instance = ModalInstance,
  ...props
}: AILoadingModalProps & {
  instance?: ReturnType<typeof Modal>;
}) => {
  ModalInstance.open({
    children: <AILoadingModal {...props} />,
    className: styles.loadingModal,
    closeButton: false,
    keepOnBackdropClick: true,
  });

  return {
    closeAILoadingModal: () => {
      instance.close();
    },
  };
};
